import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import API from '../../utils/api';
import MemberHeader from '../../components/member/MemberHeader';
import MemberSidebar from '../../components/member/MemberSidebar';
import MemberHome from '../../components/member/MemberHome';
import MemberClassSchedule from './ClassSchedule';


const MemberDashboard = () => {
  const { member, logout, socket } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activePage, setActivePage] = useState('home');
  const [notifications, setNotifications] = useState([]);

 useEffect(() => {
  fetchNotifications();
}, []);

useEffect(() => {
  if (socket) {
    // Listen for new notifications
    socket.on('new_announcement', () => {
      fetchNotifications();
    });
    socket.on('costume_borrowed', () => {
      fetchNotifications();
    });
    socket.on('instrument_borrowed', () => {
      fetchNotifications();
    });
    socket.on('new_fine', () => {
      fetchNotifications();
    });
    socket.on('performance_assigned', () => {
      fetchNotifications();
    });
    socket.on('consecutive_absences', () => {
      fetchNotifications();
    });
  }
}, [socket]);

  const fetchNotifications = async () => {
    try {
      const res = await API.get('/notifications');
      setNotifications(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={styles.container}>
      <MemberHeader
        member={member}
        onBurgerClick={() => setSidebarOpen(!sidebarOpen)}
        onLogout={handleLogout}
        notifications={notifications}
        setNotifications={setNotifications}
      />
      <MemberSidebar
        isOpen={sidebarOpen}
        activePage={activePage}
        setActivePage={setActivePage}
        onClose={() => setSidebarOpen(false)}
        member={member}
      />
      {sidebarOpen && (
        <div style={styles.overlay}
          onClick={() => setSidebarOpen(false)} />
      )}
      <div style={styles.main}>
        {activePage === 'home' && (
          <MemberHome member={member} setActivePage={setActivePage} />
        )}
        {activePage === 'schedule' && <MemberClassSchedule />}
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#f0f2f5',
    fontFamily: "'Segoe UI', sans-serif",
  },
  main: {
    marginTop: '65px',
    padding: '20px',
    minHeight: 'calc(100vh - 65px)',
  },
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 998,
  },
};

export default MemberDashboard;